import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * Address will render a formatted presentation of an HTML Address element using supplied location data.
 *
 */
import { jsxs as _jsxs } from "react/jsx-runtime";
function Address(_ref) {
  let {
    location,
    inline = false,
    ...rest
  } = _ref;
  const {
    address1,
    address2,
    city,
    state,
    zip
  } = location;
  const lineClasses = clsx({
    'display-block': !inline
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "address",
    ...rest,
    children: [address1 && /*#__PURE__*/_jsxs("span", {
      className: lineClasses,
      children: [address1, inline && ', ']
    }), address2 && /*#__PURE__*/_jsxs("span", {
      className: lineClasses,
      children: [address2, inline && ', ']
    }), /*#__PURE__*/_jsxs("span", {
      className: lineClasses,
      children: [city, ",", ' ', state, ' ', zip]
    })]
  });
}
export default Address;